export const GREEDY_FEE = {
  isHidden: true,
  nickname: 'PRODUCTS.GREEDY_FEE.nickname',
  icon:'greedy-fee'
};
